import type { Component } from 'vue';
import { RouteName } from '@/router/route-names';

const components = new Map<string, () => Promise<Component>>();

components.set(
  RouteName.ActiviteitenAfspraken,
  () => import('@/areas/activiteiten/views/afspraken.vue'),
);
components.set(
  RouteName.ActiviteitenActiviteitenOverzicht,
  () => import('@/common/areas/taken.vue'),
);
components.set(
  RouteName.ActiviteitenDocumenten,
  () => import('@/areas/activiteiten/views/documenten.vue'),
);
components.set(
  RouteName.ActiviteitenOverzicht,
  () => import('@/areas/activiteiten/views/overzicht.vue'),
);
components.set(RouteName.Admin, () => import('@/areas/admin/views/index.vue'));
components.set(
  RouteName.AdminUserTools,
  () => import('@/areas/admin/views/user-tools.vue'),
);
components.set(
  RouteName.AdminFeatureFlags,
  () => import('@/areas/admin/views/feature-flags.vue'),
);
components.set(
  RouteName.AdminOrganisations,
  () => import('@/areas/admin/views/organisations.vue'),
);
components.set(
  RouteName.AdminNotificationAfterLogin,
  () => import('@/areas/admin/views/notification-after-login.vue'),
);
components.set(
  RouteName.AdminVerwerkersovereenkomst,
  () => import('@/areas/admin/views/verwerkersovereenkomst.vue'),
);
if (import.meta.env.MODE === 'development') {
  components.set(
    RouteName.AdminDevelopmentToggles,
    () => import('@/areas/admin/views/development-toggles.vue'),
  );
}
components.set(
  RouteName.BeheerZvdZRequestAccess,
  () => import('@/areas/beheerZvdZ/views/toegang-verzoeken.vue'),
);
components.set(
  RouteName.ContactIndex,
  () => import('@/areas/contact/views/index.vue'),
);
components.set(
  RouteName.ContractenIndex,
  () => import('@/areas/contracten/views/Index.vue'),
);
components.set(
  RouteName.FacturenIndex,
  () => import('@/areas/facturen/views/Index.vue'),
);
components.set(
  RouteName.GebruikersBeheer,
  () => import('@/areas/gebruikersBeheer/views/index.vue'),
);
components.set(
  RouteName.GebruikersBeheerGebruiker,
  () => import('@/areas/gebruikersBeheer/views/gebruiker.vue'),
);
components.set(
  RouteName.GebruikersBeheerGebruikers,
  () => import('@/areas/gebruikersBeheer/views/gebruikers.vue'),
);
components.set(
  RouteName.GebruikersBeheerVervangingRegelen,
  () => import('@/areas/gebruikersBeheer/views/vervanging-regelen.vue'),
);
components.set(
  RouteName.GebruikersBeheerTwoFactor,
  () => import('@/areas/gebruikersBeheer/views/two-factor.vue'),
);
components.set(
  RouteName.GebruikersvoorwaardenIndex,
  () => import('@/areas/gebruikersvoorwaarden/views/Index.vue'),
);
components.set(
  RouteName.PaginaNietGevonden,
  () => import('@/router/NotFound.vue'),
);
components.set(
  RouteName.HomeNietGeautoriseerd,
  () => import('@/router/Unauthorised.vue'),
);
components.set(
  RouteName.HomeIndex,
  () => import('@/areas/home/views/index/Index.vue'),
);
components.set(
  RouteName.LoginGebruikersNaamWijzigen,
  () => import('@/areas/login/views/GebruikersnaamWijzigen.vue'),
);
components.set(
  RouteName.LoggedOut,
  () => import('@/areas/login/views/LoggedOut.vue'),
);
components.set(
  RouteName.LoginIndex,
  () => import('@/areas/login/views/index/Index.vue'),
);
components.set(
  RouteName.LoginPasswordRecovery,
  () => import('@/areas/login/views/ActivationOrPasswordRecovery.vue'),
);
components.set(
  RouteName.MijnProfielBevestigContactgegevens,
  () => import('@/areas/mijnProfiel/views/ConfirmContactData.vue'),
);
components.set(
  RouteName.MijnProfielIndex,
  () => import('@/areas/mijnProfiel/views/index.vue'),
);
components.set(
  RouteName.MijnProfielMijnAccount,
  () => import('@/areas/mijnProfiel/views/mijn-account/MijnAccount.vue'),
);
components.set(
  RouteName.MijnProfielMijnAutorisatie,
  () => import('@/areas/mijnProfiel/views/mijn-toegang.vue'),
);
components.set(
  RouteName.MijnProfielMijnVervanging,
  () => import('@/areas/mijnProfiel/views/mijn-vervanging/MijnVervanging.vue'),
);
components.set(
  RouteName.ProlongatieIndex,
  () => import('@/areas/prolongatie/views/index.vue'),
);
components.set(
  RouteName.RapportenBasisDashboard,
  () => import('@/areas/rapporten/views/basis-dashboard.vue'),
);
components.set(
  RouteName.RapportenUitgebreidDashboard,
  () => import('@/areas/rapporten/views/uitgebreid-dashboard.vue'),
);
components.set(
  RouteName.RapportenBasis,
  () => import('@/areas/rapporten/views/Basis.vue'),
);
components.set(
  RouteName.RapportenVerzuimhistorie,
  () => import('@/areas/rapporten/views/VerzuimHistory.vue'),
);
components.set(
  RouteName.RapportenWgaStatus,
  () => import('@/areas/rapporten/views/WgaStatus.vue'),
);
components.set(
  RouteName.RapportenWAOStatus,
  () => import('@/areas/rapporten/views/WaoStatus.vue'),
);
components.set(
  RouteName.RapportenNoRiskpolis,
  () => import('@/areas/rapporten/views/Noriskpolis.vue'),
);
components.set(
  RouteName.RapportenUitDienst,
  () => import('@/areas/rapporten/views/UitDienst.vue'),
);
components.set(
  RouteName.RapportenExport,
  () => import('@/areas/rapporten/views/Export.vue'),
);
components.set(
  RouteName.RegistratieAanmelden,
  () => import('@/areas/registratie/views/aanmelden.vue'),
);
components.set(
  RouteName.SchadelastbeheersingSchadelastbeheersing,
  () => import('@/areas/schadelastbeheersing/views/schadelastbeheersing.vue'),
);
components.set(
  RouteName.SettingsAssurantie,
  () => import('@/areas/settings/views/assurantie.vue'),
);
components.set(
  RouteName.SettingsVerzuimProtocol,
  () => import('@/areas/settings/views/verzuim-protocol.vue'),
);
components.set(
  RouteName.SettingsOrganisatieProtocol,
  () => import('@/areas/settings/views/organisatie-protocol.vue'),
);
components.set(
  RouteName.SettingsCorrespondentie,
  () => import('@/areas/settings/views/correspondentie.vue'),
);
components.set(
  RouteName.Settings,
  () => import('@/areas/settings/views/index.vue'),
);
components.set(
  RouteName.SettingsModules,
  () => import('@/areas/settings/views/modules.vue'),
);
components.set(
  RouteName.SsoNietGeautoriseerd,
  () => import('@/areas/login/views/SsoNietGeautoriseerd.vue'),
);
const Triage = () => import('@/areas/triage/Triage.vue');
components.set(RouteName.TriageWG, Triage);
components.set(RouteName.TriageWN, Triage);
components.set(
  RouteName.UwGegevensIndex,
  () => import('@/areas/uwGegevens/views/index.vue'),
);
components.set(
  RouteName.VerwerkersovereenkomstIndex,
  () => import('@/areas/verwerkersovereenkomst/views/Index.vue'),
);
components.set(
  RouteName.VideogesprekIndex,
  () => import('@/areas/videogesprek/views/index.vue'),
);
components.set(
  RouteName.WerknemerDossierVRDossier,
  () => import('@/areas/werknemerDossier/views/vrdossier.vue'),
);
components.set(
  RouteName.WerknemerDossierWgaDossier,
  () => import('@/areas/werknemerDossier/views/wga-dossier.vue'),
);
components.set(
  RouteName.WerknemerIndex,
  () => import('@/areas/werknemer/views/Index.vue'),
);
components.set(
  RouteName.WerknemerCorrespondentie,
  () => import('@/areas/werknemer/views/correspondentie.vue'),
);
components.set(
  RouteName.WerknemerAfspraken,
  () => import('@/areas/activiteiten/views/afspraken.vue'),
);
components.set(
  RouteName.WerknemerWerknemer,
  () => import('@/areas/werknemer/views/werknemer/werknemer.vue'),
);
components.set(
  RouteName.WerknemerPersoonsgegevens,
  () => import('@/areas/werknemer/views/persoonsgegevens.vue'),
);
components.set(
  RouteName.WerknemerWerknemersgegevens,
  () => import('@/areas/werknemer/views/werknemersgegevens.vue'),
);
components.set(
  RouteName.WerknemerDienstverband,
  () => import('@/areas/werknemer/views/dienstverband.vue'),
);
components.set(
  RouteName.WerknemerVerzuimHistorie,
  () => import('@/areas/werknemer/views/verzuim-historie.vue'),
);
components.set(
  RouteName.WerknemerVerzuimkalender,
  () => import('@/areas/werknemer/views/verzuimkalender/Verzuimkalender.vue'),
);
components.set(
  RouteName.WerknemerDossiertoegang,
  () => import('@/areas/werknemer/views/Dossiertoegang.vue'),
);
components.set(RouteName.WrongPortal, () => import('@/router/WrongPortal.vue'));
components.set(
  RouteName.ZelfserviceIndex,
  () => import('@/areas/zelfservice/views/index.vue'),
);

export default components;
